import { Typography, Flex } from "antd";
import { TitleCardsList } from "Components/SelectableCard/Title";

const EducationLevels = [
  {
    title: "Bachelor's",
    value: "Bachelors",
  },
  {
    title: "Master's",
    value: "Masters",
  },
];

export const LevelofEducation = ({ selectedCard, setSelectedCard }) => {
  const { Title } = Typography;
  return (
    <Flex
      vertical
      justify="flex-start"
      align="flex-start"
      style={{ marginTop: "24px" }}
    >
      <Title style={{ fontSize: "18px" }}>Degree level</Title>
      <Flex wrap>
        <TitleCardsList
          options={EducationLevels}
          selectedCard={selectedCard}
          setSelectedCard={setSelectedCard}
        />
      </Flex>
    </Flex>
  );
};
